import apiClient from './apiClient';

const normalizeNotification = (n) => ({ ...n, channel: n.channel?.toLowerCase(), status: n.status?.toLowerCase() });

export async function fetchNotifications() {
  const { data } = await apiClient.get('/notifications');
  return data.map(normalizeNotification);
}


export async function dispatchNotification(payload) {
  const { data } = await apiClient.post('/notifications', { ...payload, channel: payload.channel?.toUpperCase(), recipients: payload.recipients ?? (payload.recipient ? [payload.recipient] : []) });
  return data.map(normalizeNotification);
}

export async function markNotificationRead(id) {
  const { data } = await apiClient.patch(`/notifications/${id}/read`);
  return normalizeNotification(data);
}
